import * as types from './types';
import { loading } from 'State/actions';

export const getStatusChangeReport = data => {
  return async (dispatch, getState, MPWWebAPI) => {
    dispatch(loading(types.STATUS_CHANGE_LOADING, true));

    try {
      const response = await MPWWebAPI.postGenericInsertUpdate(
        'Reports/statusChange',
        data
      );
      dispatch({
        type: types.STATUS_CHANGE_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.STATUS_CHANGE_LOAD_ERROR,
        loadError: error.response.Errors,
      });
    }

    dispatch(loading(types.STATUS_CHANGE_LOADING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.STATUS_CHANGE_GET_REPORT,
    payload: null,
  };
};

export const setSelectedSites = selectedSites => {
  return async dispatch => {
    return dispatch({
      type: types.STATUS_CHANGE_SET_SELECTED_SITES,
      payload: selectedSites,
    });
  };
};

export const clearErrors = () => {
  return {
    type: types.STATUS_CHANGE_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/statuschange/state/report/actions.js